/**
 * User-friendly error messages mapped to HTTP status codes and error categories
 */

import { ErrorCategory } from "./types";

export const ERROR_MESSAGES: Record<number, string> = {
	400: "The request was invalid. Please check your input and try again.",
	401: "You need to be logged in to perform this action.",
	403: "You don't have permission to perform this action.",
	404: "The requested resource could not be found.",
	409: "This action conflicts with existing data.",
	422: "Please check the form for validation errors.",
	429: "Too many requests. Please wait a moment and try again.",
	500: "Something went wrong on our end. Please try again later.",
	503: "The service is temporarily unavailable. Please try again in a few moments.",
};

export const CATEGORY_MESSAGES: Record<ErrorCategory, string> = {
	[ErrorCategory.NETWORK]:
		"Unable to connect. Please check your internet connection and try again.",
	[ErrorCategory.AUTH]: "Authentication failed. Please log in again.",
	[ErrorCategory.VALIDATION]: "Please fix the errors in the form and try again.",
	[ErrorCategory.BUSINESS]: "This action couldn't be completed. Please review your input.",
	[ErrorCategory.NOT_FOUND]: "The item you're looking for doesn't exist.",
	[ErrorCategory.SERVER]: "We're experiencing technical difficulties. Please try again later.",
	[ErrorCategory.UNKNOWN]: "An unexpected error occurred. Please try again.",
};

/**
 * Get a user-friendly error message for a given status code
 */
export function getErrorMessage(status?: number, category?: ErrorCategory): string {
	if (status && ERROR_MESSAGES[status]) {
		return ERROR_MESSAGES[status];
	}

	if (category && CATEGORY_MESSAGES[category]) {
		return CATEGORY_MESSAGES[category];
	}

	return CATEGORY_MESSAGES[ErrorCategory.UNKNOWN];
}

/**
 * Action-specific error message templates
 */
export const ACTION_ERRORS = {
	fetch: (resource: string) => `Failed to load ${resource}. Please try again.`,
	create: (resource: string) => `Failed to create ${resource}. Please try again.`,
	update: (resource: string) => `Failed to update ${resource}. Please try again.`,
	delete: (resource: string) => `Failed to delete ${resource}. Please try again.`,
	connect: (service: string) => `Failed to connect to ${service}. Please try again.`,
	disconnect: (service: string) => `Failed to disconnect from ${service}. Please try again.`,
};
